// extracted by mini-css-extract-plugin
module.exports = {"component":"header-carousel-search_component__P_5e_","searchBar":"header-carousel-search_searchBar__gV17Z"};